import { Store } from '@ngrx/store';
import { authActions } from './store/auth.actions';

export function autologinAppInitializerFn(store: Store) {
    return function autoLogin() {
        store.dispatch(authActions.autologin());
    };
}
